import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/site/PageHeader";
import { PhotographerCard } from "@/components/site/PhotographerCard";
import { Reveal } from "@/components/site/Motion";

export default function Photographers() {
  const { data, loading } = useFetch("/photographers", []);
  const list = Array.isArray(data) ? data : [];
  return (
    <main data-testid="photographers-page">
      <PageHeader eyebrow="Rede Eutevila" title={["Fotógrafos", <span key="b" className="text-flash">associados.</span>]} testid="photographers-header">
        <p className="mt-6 max-w-xl text-haze md:text-lg">Escolha um profissional, peça orçamento ou reserve a data do seu evento direto pelo site.</p>
      </PageHeader>
      <section className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        {loading ? <p className="text-haze">Carregando…</p> : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="photographers-grid">
            {list.map((p, i) => <Reveal key={p.id} delay={(i % 3) * 0.06}><PhotographerCard p={p} index={i} /></Reveal>)}
          </div>
        )}
        {!loading && !list.length && <p className="text-haze" data-testid="photographers-empty">Em breve novos fotógrafos por aqui.</p>}
      </section>
    </main>
  );
}
